import React from 'react'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { BetterLink } from '~/components/features/BetterLink'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type DocumentReport } from '../hooks/useDocumentReportsInfiniteQuery'

export type TitleCellProps = {
  dataItem: DocumentReport
}

export const TitleCell = ({ dataItem: documentReport }: TitleCellProps) => {
  const brandAccountId = useBrandAccountId()
  const to = React.useMemo(
    () =>
      compile('documentReportEdit', {
        brandAccountId,
        documentReportId: documentReport.id,
      }),
    [brandAccountId, documentReport.id],
  )

  return (
    <td>
      <BetterLink logEventName="Open document" to={to}>
        {documentReport.title}
      </BetterLink>
    </td>
  )
}
